<!-- The flex row is this inner element, not the host: anything else the footer
     renders (the cookie dialog below) would otherwise become a third flex item
     and drag the links out of the right-hand corner. -->
<div class="footer-bar">
    <span class="footer-version">{{ 'common.version' | translate }} {{ appVersion }}</span>
    <span class="footer-actions">
        <a href="mailto:scan@d-carbonize.eu" target="_blank">
            <span class="material-symbols-outlined icon-sm" aria-hidden="true">bug_report</span>
            {{ 'common.bug' | translate }}
        </a>
        <span class="footer-separator" aria-hidden="true">·</span>
        <button type="button" (click)="openCookiePreferences()">
            <span class="material-symbols-outlined icon-sm" aria-hidden="true">cookie</span>
            {{ 'cookie.preferences' | translate }}
        </button>
    </span>
</div>

<app-cookie-preferences [(visible)]="preferencesVisible"></app-cookie-preferences>
